import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $accountCardListStore, $transferReasonsStore } from '@lib/store';
import { RoutePaths } from '@shared/utils';
import { type AccountResponse, AccountType } from '@shared/api/rest/accounts';
import { TransferRequestTypeEnum } from '@shared/api/rest/transferRequests/models/enums';
import { Icon, PageContainer, Text } from '@shared/widgets';
import { SelectAccount } from '@shared/widgets/select';
import { Tabs } from '@shared/widgets';
import { OwnAccountTab } from './ownAccountTab';
import { OtherAccountTab } from './otherAccountTab';
import ArrowIcon from '@assets/icons/arrow.svg';

const TABS = [
  {
    label: 'Between accounts',
    value: TransferRequestTypeEnum.BetweenInsigniaAccount,
  },
  {
    label: 'Other Insignia account',
    value: TransferRequestTypeEnum.OtherInsigniaAccount,
  },
];

export const BetweenAccountsPage = () => {
  const accountStore = useUnit($accountCardListStore.store);

  const [account, setAccount] = useState<AccountResponse | null>(null);
  const [tab, setTab] = useState<TransferRequestTypeEnum>(TransferRequestTypeEnum.BetweenInsigniaAccount);

  useEffect(() => {
    $accountCardListStore.events.update({ AccountType: AccountType.Payment });
    $transferReasonsStore.events.getTransferReasons();
  }, []);

  useEffect(() => {
    if (accountStore.data && accountStore.data.length > 0 && account === null) {
      setAccount(accountStore.data[0]);
    }
  }, [accountStore.data, account]);

  return (
    <PageContainer
      title='Payments'
      header={
        <div className='flex gap-2 items-center'>
          <Link to={RoutePaths.payments.onNavigate()}>
            <Icon icon={<ArrowIcon />} className='rotate-180' />
          </Link>
          <Text weight='semibold' size='2xl'>
            Payments
          </Text>
        </div>
      }
    >
      <div className='flex flex-col w-full'>
        <Text className='mb-6' weight='semibold' size='2xl'>
          Between accounts
        </Text>
        <div className='dark:bg-soft-black bg-white p-6'>
          <SelectAccount
            type={AccountType.Payment}
            loading={accountStore.loading}
            label='Transfer From'
            balanceFieldName='availableBalance'
            accounts={accountStore.data!}
            currentAccount={account}
            onChange={setAccount}
          />
        </div>
        <div className='dark:bg-soft-black bg-white mt-6 p-6 flex flex-col gap-2'>
          <Tabs value={tab} options={TABS} onChange={setTab} />
        </div>
      </div>
      {tab == TransferRequestTypeEnum.BetweenInsigniaAccount ? (
        <OwnAccountTab selectedAccountId={account?.id} accountFrom={account} />
      ) : (
        <OtherAccountTab account={account} />
      )}
    </PageContainer>
  );
};
